import { createIdentifier } from '@wendellhu/redi';
import type { CosCredentialPayload } from '../services/cos/cos-repo';
import type { AttachSignedUrlsOptions } from '../services/cos/cos-signed-url';
import type { CosObjectBlobProgressDetail } from '../services/cos/cos-client';

export interface ICosService {
  getCredential(): Promise<CosCredentialPayload>;
  normalizeObjectKey(pathOrKey: string): string;
  formatCosError(error: unknown): string;
  getSignedUrl(objectKey: string): Promise<string>;
  attachSignedUrls<T>(
    items: readonly T[],
    options: AttachSignedUrlsOptions<T>,
  ): Promise<T[]>;
  uploadObject(
    key: string,
    body: Blob | File,
    onProgress?: (p: number) => void,
  ): Promise<{ key: string }>;
  uploadObjects(
    files: Array<{ key: string; body: Blob | File; contentType?: string }>,
    concurrency?: number,
    onItemProgress?: (index: number, percent0to100: number) => void,
  ): Promise<Array<{ key: string }>>;
  fetchObjectBlob(
    pathOrKey: string,
    opts?: {
      onProgress?: (percent0to100: number) => void;
      onProgressDetail?: (detail: CosObjectBlobProgressDetail) => void;
    },
  ): Promise<Blob>;
}

export const ICosService = createIdentifier<ICosService>('core.cos');
